import React, { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Link } from 'react-router-dom';
import Checkbox from '@mui/material/Checkbox';
import { Modal } from 'react-bootstrap';
import OtpModal from '../Cart/OtpModal';
import { useHistory } from 'react-router-dom';
import FormGroup from '@mui/material/FormGroup';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { ConsentCheckboxesSignup } from '../../Components/ConsentCheckboxes';
import { BASE_URL } from '../../Components/client-config';
//import { signup } from '../../Redux/reducers/authSlice';


export default function LoginDetail(props: any) {
    const { setBtnDisable, firstNameError, setFirstNameError,dobError, setDobError, emailError, setEmailError, email, setEmail, firstname, setFirstname, gender, setGender, date, setDate, setEmailDisable, consentConfig = {}, consentValues = {}, setConsentValues } = props


    const [show, setShow] = useState(false);
    const history = useHistory();
    //const [emailError, setEmailError] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showPassword, setShowPassword] = useState(false);
    const [confirmshowPassword, setConfirmShowPassword] = useState(false);
    const { t } = useTranslation();

    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleshowTogglePassword = () => {
        setConfirmShowPassword(!confirmshowPassword);
    };
    const dispatch = useDispatch(); const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
    };
    const [isChecked, setIsChecked] = useState(false);
    const lang = useCurrentLocale();



    const handleEmailChange = (e: any) => {
        const input = e.target.value;
        setEmail(e.target.value);

        const emailRegex = /^\S+@\S+\.\S+$/;
        setEmailError(!emailRegex.test(input));
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleEnterPress = (e: any) => {
        // if (e.key == "Enter" && firstname && lastname && email) { 
        //     handleSignup();
        // }
    }

    const handleFirstname=(e:any)=>{
        setFirstname(e.target.value);
        if(!e.target.value){
            setFirstNameError(true)
        }
        else{
            setFirstNameError(false)
        }
    }


    const handleDate=(e:any)=>{
        const selectedDate = e.target.value;
        if (!selectedDate) {
            setDate("");
            setDobError(false);
            return;
        }
        const currentDate = new Date().toISOString().split('T')[0];
        if (selectedDate <= currentDate) {
            setDate(selectedDate);
            setDobError(false)
        } else {
            toast.error(t("FUTURE_DATE_ERROR"))
            setDate("");
            setDobError(true)
        }
    }

    useEffect(()=>{
        if(!firstname || !email){
            setBtnDisable(true)
        }
        else{
            setBtnDisable(false)
        }
    },[firstname,email])


    return (
        <div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="login-guest pb-0">
                        <div className="row">
                            {/* <div className="col-md-6">
                <img src={KFCUncle} alt="KFCUncle" />
            </div> */}
                            <div className="col-md-12">
                                <div className='welcome-login font-normal '>

                                    <div className="col-md-12 mt-1">
                                        <TextField
                                            helperText={firstNameError ? t("FIRST_NAME_IS_REQUIRED") : ""}
                                            onChange={handleFirstname}
                                            onKeyPress={handleEnterPress}
                                            value={firstname}
                                            className='field-style color-white'
                                            id="filled-basic"
                                            label={<div className='font-normal d-flex gap-1'><p>{t("FULL_NAME")}</p><p className='color-theme h4'>*</p></div>}
                                            variant="filled"
                                            color="error"
                                        />
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <TextField onKeyPress={handleEnterPress} value={email} onChange={handleEmailChange}
                                            helperText={emailError ? t("EMAIL_IS_REQUIRED") : ''}
                                            className='field-style color-white' id="filled-basic" label={<div className='font-normal d-flex gap-1'><p>{t("EMAIL")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <TextField type='date'
                                            value={date}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            onChange={handleDate}
                                            name="dateofbirth"
                                            onKeyPress={handleEnterPress}
                                            className='field-style' id="filled-basic"
                                            label={`${t("DOB")} *`}
                                            variant="filled"
                                            color="error" />
                                    </div>
                                    {setConsentValues && (
                                        <ConsentCheckboxesSignup
                                            config={consentConfig}
                                            values={consentValues}
                                            onChange={setConsentValues}
                                            privacyPolicyUrl={`${BASE_URL}privacy-policy`}
                                        />
                                    )}
                                    {/* <div className="guest-password row">
                                        <div className="col-md-6 mt-3">
                                            <TextField
                                                name="input2"
                                                className='field-style' id="filled-basic" type='' label="Password" variant="filled" color="error" />
                                        </div>
                                        <div className="col-md-6 mt-3">
                                            <TextField
                                                name="input2"
                                                className='field-style' id="filled-basic" type='' label="Confirm Password" variant="filled" color="error" />
                                        </div>
                                    </div> */}
                                    <FormControl>
                                        <h6 className='font-normal color-white mt-3 mb-0 h5'>{t("GENDER")}</h6>

                                        <RadioGroup
                                            value={gender}
                                            onChange={(e) => setGender(e.target.value)}
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel className='color-white' value="Male" control={<Radio className='color-theme' />} label={t("MALE")} />
                                            <FormControlLabel className='color-white' value="Female" control={<Radio className='color-theme' />} label={t("FEMALE")} />
                                            <FormControlLabel className='color-white' value="Others" control={<Radio className='color-theme' />} label={t("OTHERS")} />
                                        </RadioGroup>
                                    </FormControl>
                                    {/* <div className="signup-login col-md-12 mt-3">
                                        <FormGroup>
                                            <FormControlLabel className='color-white signup-text'
                                                control={<Checkbox
                                                    checked={isChecked}
                                                    onChange={handleCheckboxChange}
                                                    inputProps={{ "aria-label": "controlled" }}
                                                    className='color-theme' />} label="Sign up now to avail exclusive rewards & discounts" />
                                        </FormGroup>
                                    </div> */}
                                    {isChecked &&
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <div className='position-relative'>
                                                    <TextField
                                                        name="input2"
                                                        className='field-style' id="filled-basic" autoComplete="new-password" type={showPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>{t("PASSWORD")}</p><p className='color-theme h4'></p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleTogglePassword} className='eye-btn' color="error"><i className={showPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-3">
                                                <div className='position-relative'>
                                                    <TextField
                                                        name="input2"
                                                        className='field-style' id="filled-basic" autoComplete="new-password" type={confirmshowPassword ? 'text' : 'password'} label={<div className='font-normal d-flex gap-1'><p>{t("CONFIRM_PASSWORD")}</p><p className='color-theme h4'></p></div>} variant="filled" color="error" />
                                                    <Button onClick={handleshowTogglePassword} className='eye-btn' color="error"><i className={confirmshowPassword ? 'ri-eye-off-fill' : 'ri-eye-fill'}></i></Button>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
